var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M2 5.6875L1.46967 6.21783L0.939339 5.6875L1.46967 5.15717L2 5.6875ZM6.6875 16.75C6.27329 16.75 5.9375 16.4142 5.9375 16C5.9375 15.5858 6.27329 15.25 6.6875 15.25L6.6875 16.75ZM6.15717 10.9053L1.46967 6.21783L2.53033 5.15717L7.21783 9.84467L6.15717 10.9053ZM1.46967 5.15717L6.15717 0.46967L7.21783 1.53033L2.53033 6.21783L1.46967 5.15717ZM2 4.9375L11.8437 4.9375L11.8437 6.4375L2 6.4375L2 4.9375ZM11.8437 16.75L6.6875 16.75L6.6875 15.25L11.8437 15.25L11.8437 16.75ZM17.75 10.8437C17.75 14.1057 15.1057 16.75 11.8437 16.75L11.8437 15.25C14.2773 15.25 16.25 13.2773 16.25 10.8437L17.75 10.8437ZM11.8437 4.9375C15.1057 4.9375 17.75 7.58182 17.75 10.8437L16.25 10.8437C16.25 8.41024 14.2773 6.4375 11.8437 6.4375L11.8437 4.9375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.a611123865265749c519233b926cc94e.svg";
export { ForwardRef as ReactComponent };